import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [
        { id: 1, name: "Lisa Guijarro", role: "Étudiant", email: "lisa.guijarro@ecole.edu", phone: "+41 7 12 34 56 78", status: "Actif", avatar: "/avatars/student.png" },
        { id: 2, name: "Jean-Marie Mettetal", role: "Enseignant", email: "jean-marie.mettetal@ecole.edu", phone: "+41 6 12 34 56 78", status: "Actif", avatar: "/avatars/teacher.png" },
        { id: 3, name: "Noémie Henry", role: "Bibliothécaire", email: "noemie.henry@ecole.edu", phone: "+41 6 12 34 56 78", status: "Actif", avatar: "/avatars/librarian.png" },
        { id: 4, name: "Patrick Guijarro", role: "Enseignant", email: "patrick.guijarro@ecole.edu", phone: "+41 6 12 34 56 78", status: "Actif", avatar: "/avatars/teacher.png" },
    ],
    roleAvatars: {
        "Étudiant": "/avatars/student.png",
        "Enseignant": "/avatars/teacher.png",
        "Bibliothécaire": "/avatars/librarian.png"
    },
    categories: [
        { id: 'Bibliothécaire', label: 'Bibliothécaires', iconName: 'Book' },
        { id: 'Enseignant', label: 'Enseignants', iconName: 'GraduationCap' },
        { id: 'Étudiant', label: 'Étudiants', iconName: 'User' },
    ],
    currentMember: null,
    searchQuery: ""
};

const membersSlice = createSlice({
    name: 'members',
    initialState,
    reducers: {
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        addMember: (state, action) => {
            state.items.push({ ...action.payload, id: state.items.length + 1 });
        },
        updateMember: (state, action) => {
            const index = state.items.findIndex(m => (m.ID || m.id) === (action.payload.ID || action.payload.id));
            if (index !== -1) {
                state.items[index] = { ...state.items[index], ...action.payload };
            }
        },
        deleteMember: (state, action) => {
            state.items = state.items.filter(m => (m.ID || m.id) != action.payload);
        },
        setCurrentMember: (state, action) => {
            state.currentMember = action.payload;
        },
        setMembers: (state, action) => {
            const uniqueMembers = [];
            const ids = new Set();
            if (Array.isArray(action.payload)) {
                for (const member of action.payload) {
                    const id = member.ID || member.id;
                    if (!ids.has(id)) {
                        ids.add(id);
                        uniqueMembers.push(member);
                    }
                }
            }
            state.items = uniqueMembers;
        },
    }
});

export const { addMember, updateMember, deleteMember, setMembers, setCurrentMember, setSearchQuery } = membersSlice.actions;
export default membersSlice.reducer;
